import React, { Component } from 'react';

import CourseBox from '../CourseBox/Component';

import './style.css';

class NotValidScolarships extends Component {
  render() {
    const courses = this.props.courses || [];

    return <section className="not-valid-scolarships container">
      <div className="info-box">
        <h2 className="title">{ this.props.age ? 'Otras Becas En Red': 'Todas Las Becas' }</h2>
  
          { this.props.age 
            ?  <p>No cumplís el requerimiento de edad para los siguientes cursos. ¡Pero te invitamos conocerlos!</p>
            :  <p>A continuación podes ver todas las <strong><a href="http://becasenred.com.ar">Becas En Red</a></strong></p>
          }

      </div>
     
        <div className="row">
          { courses
              .filter((course) => ( !((course.minAge <= this.props.age) && (course.maxAge >= this.props.age)) ) )
              .sort(() => {
                if (Math.random() > 0.5) {
                  return 1;
                }
  
                return -1;
              })
              .map((course) => <div key={course.id} className="col-lg-4 col-md-6"><CourseBox course={course} /></div>) 
          }
        </div>
    </section>
  }
}

export default NotValidScolarships;


// WEBPACK FOOTER //
// ./src/components/NotValidScolarships/Component.js